module.exports = __webpack_public_path__ + "img/dot.d5a5b562.svg";